import type { CatalogItem } from "../api/types";

export interface ReceivePriceSuggestion {
  /** Per unit, before IVA, ready for the price box. */
  unitPriceEur: string;
  /** Where it came from — the button says so. */
  source: "lastDelivery" | "usualCost";
}

function positive(value: string | null | undefined): number | null {
  if (value == null || value.trim() === "") return null;
  const n = Number(value);
  return Number.isFinite(n) && n > 0 ? n : null;
}

/**
 * The receive window's one-tap price (owner, 2026-10-09, option 2): what the
 * item cost per unit on its last real delivery at any shop, else the usual cost
 * typed on the item, else nothing. A SUGGESTION, never a pre-filled box: an
 * empty box still means "unknown, nothing booked as spend", so a price is only
 * booked once a person chose it. Both figures are stored before IVA.
 */
export function receivePriceSuggestion(
  item: Pick<CatalogItem, "lastDeliveryUnitCostEur" | "defaultPurchaseUnitCostEur">,
): ReceivePriceSuggestion | null {
  const last = positive(item.lastDeliveryUnitCostEur);
  if (last !== null) return { unitPriceEur: String(Number(last.toFixed(4))), source: "lastDelivery" };
  const usual = positive(item.defaultPurchaseUnitCostEur);
  if (usual !== null) return { unitPriceEur: String(Number(usual.toFixed(4))), source: "usualCost" };
  return null;
}
